import z from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CompleteForbearanceWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('completeForbearanceWorkoutPlan'),
  workoutPlanId: WorkoutPlanId,
});
export type CompleteForbearanceWorkoutPlanEvent = z.infer<typeof CompleteForbearanceWorkoutPlanEvent>;
